import * as type from '../types';

const initialState = {
  orderMatches: [],
  matchLoading: false,
  matchError: false,
  objections: [],
  objectionsLoading: false,
  objectionsError: false,
  objectionsFilter: {
    organization: '',
    contract: '',
    type: '',
  },
  objectionsHistory: [],
  objectionsHistoryLoading: false,
  objectionsHistoryError: false,
  objectionsHistoryFilter: {
    organization: '',
    startDate: '',
    endDate: '',
    status: '-',
  },
};

export default function offers(state = initialState, action) {
  switch (action.type) {
    case type.GET_OBJECTIONS_ORDER_MATCH_REQUESTED:
      return {
        ...state,
        matchLoading: true,
        matchError: false,
      };
    case type.GET_OBJECTIONS_ORDER_MATCH_SUCCEEDED:
      return {
        ...state,
        orderMatches: action.payload,
        matchLoading: false,
        matchError: false,
      };
    case type.GET_OBJECTIONS_ORDER_MATCH_FAILED:
      return {
        ...state,
        orderMatches: [],
        matchLoading: false,
        matchError: true,
      };
    case type.GET_OBJECTIONS_REQUESTED:
      return {
        ...state,
        objectionsLoading: true,
        objectionsError: false,
      };
    case type.GET_OBJECTIONS_SUCCEEDED:
      return {
        ...state,
        objections: action.payload,
        objectionsLoading: false,
        objectionsError: false,
      };
    case type.GET_OBJECTIONS_FAILED:
      return {
        ...state,
        objections: [],
        objectionsLoading: false,
        objectionsError: true,
      };
    case type.GET_OBJECTIONS_HISTORY_REQUESTED:
      return {
        ...state,
        objectionsHistoryLoading: true,
        objectionsHistoryError: false,
      };
    case type.GET_OBJECTIONS_HISTORY_SUCCEEDED:
      return {
        ...state,
        objectionsHistory: action.payload,
        objectionsHistoryLoading: false,
        objectionsHistoryError: false,
      };
    case type.GET_OBJECTIONS_HISTORY_FAILED:
      return {
        ...state,
        objectionsHistory: [],
        objectionsHistoryLoading: false,
        objectionsHistoryError: true,
      };
    case type.SET_OBJECTIONS_FILTER:
      return {
        ...state,
        objectionsFilter: {
          ...state.objectionsFilter,
          [action.payload.type]: action.payload.value,
        },
      };
    case type.SET_OBJECTIONS_FILTER_ORGANIZATION:
      return {
        ...state,
        objectionsFilter: {
          ...state.objectionsFilter,
          organization: action.payload,
        },
      };
    case type.SET_OBJECTIONS_HISTORY_FILTER:
      return {
        ...state,
        objectionsHistoryFilter: {
          ...state.objectionsHistoryFilter,
          [action.payload.type]: action.payload.value,
        },
      };
    case type.SET_OBJECTIONS_HISTORY_FILTER_ORGANIZATION:
      return {
        ...state,
        objectionsHistoryFilter: {
          ...state.objectionsHistoryFilter,
          organization: action.payload,
        },
      };
    default:
      return state;
  }
}
